import { AddressBook } from '../../../models/address-book';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';

export class AddressBooksData implements DataSource<AddressBook> {

    constructor(private source$: Observable<AddressBook[]>) {
    }

    connect(collectionViewer: CollectionViewer): Observable<AddressBook[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {

    }

}
